module.exports = __webpack_public_path__ + "media/images/twitter-share-ae3184a7567f5bb6e15a9385215bf2fd.png";